import axios from "axios";
import httpClient from "./httpClient";
import { getApiBaseUrl } from "../data/authStorage";

const baseUrl = getApiBaseUrl();

const messageFrom = (error, fallback) => {
  const message = error?.response?.data?.message || fallback;
  return Array.isArray(message) ? message.join(", ") : message;
};

export async function requestPasswordReset(email) {
  try {
    const response = await axios.post(`${baseUrl}/auth/forgot-password`, { email });
    return response.data;
  } catch (error) {
    throw new Error(messageFrom(error, "Unable to request a password reset right now."));
  }
}

export async function resetPassword(token, password) {
  try {
    const response = await axios.post(`${baseUrl}/auth/reset-password`, { token, password });
    return response.data;
  } catch (error) {
    throw new Error(messageFrom(error, "Unable to reset your password."));
  }
}

export async function changePassword(currentPassword, newPassword) {
  try {
    const response = await httpClient.post(`${baseUrl}/auth/change-password`, {
      currentPassword,
      newPassword,
    });
    return response.data;
  } catch (error) {
    throw new Error(messageFrom(error, "Unable to change your password."));
  }
}
